/*
 *
 * Prospect constants
 *
 */

export const DEFAULT_ACTION = 'app/ProductCategory/DEFAULT_ACTION';
